import NavigableValidation from "./navigableValidation";
import DetailViewContentElement from "../detailView/elements/detailViewContentElement";
import ContentElementPropertiesValidator from "../navigableValidators/contentElementPropertiesValidator";
import {DetailViewContentElementType} from "~/enums/detailViews/detailViewContentElementType";
import {IErrorNavOpts} from "~/models/validationError";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";
import PresenceValidator from "~/models/validators/presenceValidator";
import {ValidationErrorMessage} from "~/enums/validationErrorMessage";
import {ErrorType} from "~/enums/ErrorType";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import FormList from "../../../formability/detailViewBuilder/models/formList";
import FieldPresenceValidator from "~/models/navigableValidators/fieldPresenceValidator";
import {RelationSection} from "../../../formability/detailViewBuilder/models/relationSection";
import RelationSectionLinkedDetailViewsValidator from "~/models/navigableValidators/relationSectionLinkedDetailViewsValidator";

export default class DetailViewContentElementValidation extends NavigableValidation<DetailViewContentElement> {
  _validators: NavigableValidator<DetailViewContentElement>[] = [
    new ContentElementPropertiesValidator({
      validatorKey: 'content_elements',
      section: ValidationModalSection.Layout
    }),
    new NavigableValidator({
      validatorKey: 'property_id',
      section: ValidationModalSection.Layout,
      conditional: (model: DetailViewContentElement, validatorKey) => {
        return model.content_type === DetailViewContentElementType.ModelProperty
      },
      validator: (value, model: DetailViewContentElement) => {        
        return PresenceValidator.isValid(value) || PresenceValidator.isValid(model['builtin_property_type']) || PresenceValidator.isValid(model['reference_path']);
      },
      message: ValidationErrorMessage.MustBePresent,
      type: ErrorType.mustBePresent
    }),
    new FieldPresenceValidator({
      validatorKey: 'linked_form_ids',
      section: ValidationModalSection.Layout,
      conditional: (model: FormList, validatorKey) => {
        return model.content_type === DetailViewContentElementType.FormList
      },
      displayName: "List of Forms",
      message: "Please add forms to your Form List element",
      anchorHash: "form-list-search",
      targetElementId: "form-list-search"
    }),
    new FieldPresenceValidator({
      validatorKey: 'label_title',
      section: ValidationModalSection.Layout,
      conditional: (model: DetailViewContentElement, validatorKey) => {
        return model.content_type === DetailViewContentElementType.PageTitle;
      },
      displayName: 'Page Title',
      message: "Please specify a page title your Detail View.",
    }),
    new NavigableValidator({
      validatorKey: 'property_id',
      section: ValidationModalSection.Layout,
      conditional: (model: DetailViewContentElement, validatorKey) => {
        return model.content_type === DetailViewContentElementType.Actions
      },
      validator: (value, model: DetailViewContentElement) => {
        return !model.contentElementsArray.find(e => {
            const action = model.objectModel.findObjectModelAction(e.action_client_id);
            return !action
        })
      },
      message: ValidationErrorMessage.MustBePresent,
      type: ErrorType.mustBePresent
    }),
    new NavigableValidator({
      validatorKey: 'relation_id',
      section: ValidationModalSection.Layout,
      conditional: (model: DetailViewContentElement, validatorKey) => {
        return model.content_type === DetailViewContentElementType.RelationSection;
      },
      validator: (value, model: RelationSection) => {
        return PresenceValidator.isValid(value);
      },
      displayName: 'Relation Section: Role of "Has One" Related Object',
      message: ValidationErrorMessage.MustBePresent,
      type: ErrorType.mustBePresent
    }),
    new RelationSectionLinkedDetailViewsValidator({
      section: ValidationModalSection.Layout,
      conditional(model: DetailViewContentElement) {
        return model.content_type === DetailViewContentElementType.RelationSection;
      }
    })
  ];

  get validators() {
    if (!this.hasValidatorFor('relation_section_linked_detail_views') && this.model.content_type === DetailViewContentElementType.RelationSection) {
      this._validators.push(new RelationSectionLinkedDetailViewsValidator({
        section: ValidationModalSection.Layout
      }));
    }

    return this._validators;
  }

  hasValidatorFor(field: string): boolean {
    return this._validators.some(it => it.field === field);
  }

  errorNavOpts(validator, field: string, value?): IErrorNavOpts{
    const opts = super.errorNavOpts(validator, field, value);
    const targetElementId = validator.options.targetElementId || this.model.idForProp(field);
    Object.assign(opts, {
      path: validator.section.toLowerCase(),
      query: {selectedId: this.model.client_id},
      targetElementId: targetElementId
    })
    return opts;
  }
}